import { actionTypes } from '../constants';

const createInitialState = () => ({
  search: '',
  filter: undefined,
});

export const reducer = (state = createInitialState(), { type, payload }) => {
  switch (type) {
    case actionTypes.currentCompanyChanged:
    case actionTypes.currentCityChanged:
    case actionTypes.createReset:
    case actionTypes.roomStateReset:
    case actionTypes.allHousesDeselected: {
      if (state.search === '' && state.filter === undefined) {
        return state;
      }

      return createInitialState();
    }

    case actionTypes.roomSearchChanged: {
      return { ...state, search: payload };
    }

    case actionTypes.roomFilterChanged: {
      return { ...state, filter: payload };
    }

    default:
      return state;
  }
};
